<template>
  <v-dialog
    class="layer-popup"
    width="500"
    v-model="active"
  >
    <v-card class="justify-center text-center">
      <v-card-title
        class="headline justify-center"
        primary-title
        v-html="msgTitle"
      >
      </v-card-title>
      <v-card-text class="" v-html="msg">
      </v-card-text>
      <v-card-actions class="justify-center">
        <template v-if="isChoice">
          <v-btn
            depressed
            large
            tile
            @click="cancelModal"
          >
            {{ cancelText }}
          </v-btn>
        </template>
        <v-btn
          color="primary"
          depressed
          large
          tile
          @click="confirmModal"
        >

          {{ okText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '../../utils/eventBus'
export default {
  data () {
    return {
      active: false,
      msgTitle: '알림',
      msg: '',
      okText: '확인',
      cancelText: '돌아가기',
      confirmHandler: null,
      isChoice: true
    }
  },
  methods: {
    resetDialog () {
      this.active = false
      this.msgTitle = '알림'
      this.msg = ''
      this.okText = '확인'
      this.cancelText = '돌아가기'
      this.confirmHandler = null
      this.isChoice = true
    },
    modalContent (payload) {
      this.active = payload.active
      this.msg = payload.msg || this.msg
      this.msgTitle = payload.msgTitle || this.msgTitle
      this.confirmHandler = payload.confirmHandler || this.confirmHandler
      this.isChoice = !payload.isChoice ? payload.isChoice : this.isChoice
      this.okText = payload.okText || this.okText
      this.cancelText = payload.cancelText || this.cancelText
    },
    cancelModal () {
      if (this.confirmHandler && this.confirmHandler.cancel) {
        this.confirmHandler.cancel()
      }
      this.resetDialog()
      this.active = false
    },
    confirmModal () {
      if (this.confirmHandler && this.confirmHandler.ok) {
        this.confirmHandler.ok()
      }
      this.resetDialog()
      this.active = false
    }
  },
  beforeMount () {
    eventBus.$on('dialog', this.modalContent)
  },
  beforeDestroy () {
    eventBus.$off('dialog', this.modalContent)
  }
}
</script>
<style scoped lang="scss">
  .layer-popup {
    .v-card {
      padding: 20px;
    }
  }
  .v-dialog {
    .v-card {
      padding: 30px 0 20px;
      .v-card__title.headline {
        text-align: center;
        font-weight: 500;
        font-size: 1.3rem !important;
        padding: 20px 0 20px;
      }
      .v-card__text {
        font-size: 1rem;
      }
    }
    .v-card__actions > .v-btn.v-btn {
      width: 44%;
    }
  }
</style>
